import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';

import Routes from 'config/routes';

import useApp from './useApp';

import AuthenticationProvider from 'domain/authentication/AuthenticationProvider';
import RecipeProvider from 'domain/recipe/RecipesProvider';
import BookmarkedRecipesProvider from 'domain/recipe/BookmarkedRecipesProvider';

import CreateAccountPage from 'pages/create_account/CreateAccountPage';
import HomePage from 'pages/home/HomePage';
import LoginPage from 'pages/login/LoginPage';
import LogoutPage from 'pages/logout/LogoutPage';

const App = () => {
  const { wasInitialized } = useApp();

  if (!wasInitialized) return <React.Fragment></React.Fragment>;

  return (
    <AuthenticationProvider>
      <BookmarkedRecipesProvider>
        <RecipeProvider>
          <SnackbarProvider maxSnack={4}>
            <BrowserRouter>
              <Switch>
                <Route path={Routes.CREATE_ACCOUNT}>
                  <CreateAccountPage></CreateAccountPage>
                </Route>

                <Route path={Routes.LOGOUT}>
                  <LogoutPage></LogoutPage>
                </Route>

                <Route path={Routes.LOGIN}>
                  <LoginPage></LoginPage>
                </Route>

                <Route path={Routes.HOME_PAGE}>
                  <HomePage />
                </Route>
              </Switch>
            </BrowserRouter>
          </SnackbarProvider>
        </RecipeProvider>
      </BookmarkedRecipesProvider>
    </AuthenticationProvider>
  );
};

export default App;
